<div class="card">
  <div 
    class="card-header app-text-white app-bg-dark d-flex justify-content-start"
    [@expandCollapseHeader]="expanded ? 'expanded' : 'collapsed'"
    role="button"
    (click)="toggleAccordion()"
  >
    <div class="d-flex align-items-center">
      <img *ngIf="user.photoUrl" [src]="user.photoUrl" class="img-thumbnail rounded-circle mr-3"
            style="height: 50px; width: 50px; object-fit: cover" (error)="user.photoUrl = ''"/>
      <img *ngIf="!user.photoUrl" appDealerIcon class="img-thumbnail rounded-circle mr-3"
            style="height: 50px; width: 50px; object-fit: cover"/>
      <span>{{ user.firstName + ' ' + user.lastName }}</span>
    </div>
  </div>
  <div [@expandCollapse]="expanded ? 'expanded' : 'collapsed'" class="user-card-body d-flex align-items-start justify-content-between">
    <div>
      <p class="card-text"><strong>User ID:</strong> {{ user.id }}</p>
      <p class="card-text text-break"><strong>Email:</strong> {{ user.email }}</p>
      <p class="card-text text-break"><strong>Phone:</strong> {{ user.smsCellNumber | phoneNumber }}</p>
      <p class="card-text text-break"><strong>Security Groups:</strong> {{ user.securityGroups || 'N/A' }}</p>
    </div>
    <div class="btn-group-vertical ml-3">
      <button *ngIf="allowEdit" class="btn btn-sm app-btn-success" type="button" (click)="edit.emit(user)" [disabled]="noSecurityGroups || waitOnAction">
        Edit
      </button>
      <ng-container *ngIf="allowDelete">
        <button *ngIf="!user.deletedAt" class="btn btn-sm app-btn-neutral" type="button" (click)="delete.emit(user)" [disabled]="waitOnAction">
          Delete
        </button>
        <button *ngIf="user.deletedAt" class="btn btn-sm app-btn-neutral" type="button" (click)="restore.emit(user)" [disabled]="waitOnAction">
          Restore
        </button>
      </ng-container>
    </div>
  </div>
</div>